<div [formGroup]="group">
  <textarea
    [id]="control.name"
    [value]="true"
    [formControlName]="control.name"
    [attr.aria-required]="isRequired ? 'true' : 'false'"
    [attr.aria-invalid]="control.hasError ? 'true' : null"
  >
  </textarea>
</div>
